import React from "react";
import { BsArrowLeft } from "react-icons/bs";
import { IoWallet } from "react-icons/io5";
import { SlArrowRight } from "react-icons/sl";
import { walletlogo } from "../../../assets/images";

const SelectType = ({
  setOpenSellFrom,
  setOpenSellFromExAddy,
  setOpenSellFromDeex,
}: any) => {
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenSellFrom(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-200 font-sora font-semibold text-[20px]">
            Sell
          </h4>
        </div>
        <h4 className="text-gray-900 dark:text-gray-200 text-[16px] mt-4">
          Sell from:
        </h4>
        <div className="w-full mt-8">
          <div
            onClick={() => {
              setOpenSellFrom(false);
              setOpenSellFromDeex(true);
            }}
            className="w-full border border-gray-200 dark:border-gray-600 p-4 rounded-xl cursor-pointer flex justify-between mt-4 items-center"
          >
            <div className="flex  items-center gap-3">
              <div className="w-[24px] h-[24px]">
                <img
                  src={walletlogo}
                  className="w-full h-full bg-cover"
                  alt=""
                />
              </div>
              <div>
                <h4 className="dark:text-gray-300 text-gray-900 font-medium text-[15px]">
                  My Deex Wallet
                </h4>
                <h4 className="dark:text-gray-400 text-gray-500 font-medium text-[13px]">
                  Sell from your wallet to fiat wallet
                </h4>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <SlArrowRight className="text-gray-600 dark:text-white text-[15px]" />
            </div>
          </div>
        </div>
        <div className="w-full mt-8">
          <div
            onClick={() => {
              setOpenSellFrom(false);
              setOpenSellFromExAddy(true);
            }}
            className="w-full border border-gray-200 dark:border-gray-600 p-4 rounded-xl cursor-pointer flex justify-between mt-4 items-center"
          >
            <div className="flex  items-center gap-3">
              <IoWallet className="text-secondary_button text-[24px]" />
              <div>
                <h4 className="dark:text-gray-300 text-gray-900 font-medium text-[15px]">
                  External Wallet
                </h4>
                <h4 className="dark:text-gray-400 text-gray-500 font-medium text-[13px]">
                  Sell from your other wallet
                </h4>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <SlArrowRight className="text-gray-600 dark:text-white text-[15px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectType;
